export default "__VITE_ASSET__DhRAoHyc__"